import React from "react";
import styled from "./Layout.styles";

interface Props {
  bottom: React.ReactNode;
  top: React.ReactNode;
}

/**
 * A 100% height layout with two 50/50 rows
 */
const Layout: React.FC<Props> = props => {
  const { bottom, top } = props;

  return (
    <>
      <styled.Spacer />
      <styled.FlexBox>
        <div id="calendar">
          <div>{top}</div>
        </div>

        <styled.Pane id="pane">{bottom}</styled.Pane>
      </styled.FlexBox>
    </>
  );
};

export default Layout;
